import { render, staticRenderFns } from "./ListingSubunitDetailComponent.vue?vue&type=template&id=08e8b447&"
import script from "./ListingSubunitDetailComponent.vue?vue&type=script&lang=js&"
export * from "./ListingSubunitDetailComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports